import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { ExtractionStatus } from '@vrzl/database';

import { apiFetch } from '@/domains/general/api/client';

import { eventKeys } from './keys';

export function useRetryExtraction(eventId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (): Promise<{ extractionStatus: ExtractionStatus }> =>
      // Lege JSON-body is verplicht: apiFetch zet Content-Type: application/json
      // en Fastify weigert een lege body bij dat content-type.
      apiFetch(`/cases/${eventId}/extraction/retry`, {
        method: 'POST',
        body: JSON.stringify({}),
      }),
    // onSettled (niet onSuccess): ook na een fout (bv. 409 door een race)
    // moet de UI de werkelijke status tonen.
    onSettled: () => {
      qc.invalidateQueries({ queryKey: eventKeys.detail(eventId) });
      qc.invalidateQueries({ queryKey: eventKeys.lists() });
    },
  });
}
